export function invitationProgress(guests) {

    let needed = guests ? guests.filter((g) => g.started) : [];

    let totalCount = 0;
    let finishedCount = 0;

    needed.forEach((guest) => {
        totalCount++;

        if (guest.progress.finished) {
            finishedCount++;
        }
    });


    return {
        total:  totalCount,
        finished:  finishedCount,
        percent:  Math.round(finishedCount / totalCount * 100),
    };
}

export function invitationReady(guests) {

    let progress = invitationProgress(guests);

    return progress.total === progress.finished;
}
